import React, { memo, useMemo } from "react";

import { CustomInput } from "components";
import { FieldWithReadOnlyMode } from "components/formFields";
import { hasPermissions, viewSensitiveDataFullPermissionSet } from "helpers";
import {
	exactNumberOfDigitsMask17,
	maxLength17,
	normalizeAll,
	required,
} from "validators";

type DDAFieldProps = {
	loading: boolean;
	value: string | undefined;
	isEditable: boolean;
};

const DDAField = ({ loading, value, isEditable }: DDAFieldProps) => {
	const isFieldEditable = useMemo(
		() => isEditable && hasPermissions(viewSensitiveDataFullPermissionSet),
		[isEditable],
	);

	return (
		<FieldWithReadOnlyMode
			label="Account Number (DDA)"
			component={CustomInput}
			smLabel={5}
			smSelect={7}
			type="text"
			validate={[required, maxLength17]}
			normalize={normalizeAll([exactNumberOfDigitsMask17])}
			name={"dda"}
			blurLoading={loading}
			readOnlyProps={{
				isEditable: isFieldEditable,
				value,
			}}
		/>
	);
};

const component = memo(DDAField);
export { component as DDAField };
